// 메신저 «채널 파일» 목록·개수에서 스티커 첨부를 뺀다(마스터 2026-10-01 «스티커로 보낸
// 이미지파일들이 채널파일에서 집계되고 있는거 같은데 제외 시켜라»).
// 설계: `patch_mm_channel_files_exclude_stickers.md`
//
// 스티커는 MM 에 **파일 첨부**로 올라간다(`utils/mmSticker`) → MM 서버는 그것을 그냥 파일로
// 센다. MM 서버·데이터는 건드리지 않고(읽기 전용 원칙), 같은 오리진 iframe 의 `fetch` 응답만
// 고쳐 **게이트웨이 화면에서만** 뺀다.
//
// 어디를 고치는가(MM 11.11 실측)
//   ① «채널 파일» RHS 목록 = `POST …/api/v4/teams/<팀>/files/search`(팀이 없으면
//      `…/api/v4/files/search`) 이고 요청 바디 `terms` 가 `channel:<채널> [ext:…]` 모양.
//      🔴 검색창의 «파일» 탭도 같은 엔드포인트지만 terms 가 사람이 입력한 말이다 → 손대지 않는다.
//   ② 채널 정보(ⓘ) «파일 N» = `GET …/api/v4/channels/<채널>/stats`(exclude_files_count 없음)
//      의 `files_count` 에서 백엔드가 센 스티커 수를 뺀다.
//
// 🔴 MM 이 응답을 읽는 방식에 맞춘다 — `Content-Type` 이 **정확히** `application/json` 일 때만
//    json() 으로 읽으므로, 새로 만드는 응답은 원본 content-type 을 그대로 둔다(본문 길이는
//    달라지니 content-length·content-encoding 은 떼어낸다).
// 🔴 어긋나면 **원래 응답 객체를 그대로** 돌려준다 — 스티커가 보일 뿐 화면은 안 깨진다.
export const STICKER_PREFIX = 'sticker_';
export const DEFAULT_TIMEOUT_MS = 3000;    // 스티커 수 조회 상한 — 넘으면 0(= 빼지 않는다)

const MM_ID = '[a-z0-9]{26}';
const STATS_RE = new RegExp('/api/v4/channels/(' + MM_ID + ')/stats$');
const FILE_SEARCH_RE = new RegExp('/api/v4/(?:teams/' + MM_ID + '/)?files/search$');
// MM 이 «채널 파일» 목록에 쓰는 terms — 채널 한정 + 파일 유형 필터(ext)뿐이다(번들 실측).
// 사람이 입력한 검색어는 이 모양이 아니므로 검색창 «파일» 탭은 여기서 빠진다.
const CHANNEL_TERMS_RE = new RegExp('^channel:' + MM_ID + '( ext:[a-z0-9]+)*$');
const TRUTHY = ['true', '1', 't'];
const DROP_HEADERS = ['content-length', 'content-encoding'];

export function isStickerName(name) {
  return typeof name === 'string' && name.indexOf(STICKER_PREFIX) === 0;
}

// files/search 응답 → 스티커를 뺀 **새** 객체. 뺄 것이 없으면 받은 객체를 그대로 돌려준다
// (호출부가 `===` 로 «안 바뀌었다» 를 가리고 원래 응답을 그대로 흘린다).
export function stripStickerFiles(data) {
  if (!data || typeof data !== 'object') return data;
  const infos = data.file_infos;
  if (!infos || typeof infos !== 'object') return data;
  const kept = {};
  let removed = 0;
  Object.keys(infos).forEach((key) => {
    const info = infos[key];
    if (info && isStickerName(info.name)) { removed += 1; return; }
    kept[key] = info;
  });
  if (!removed) return data;
  const out = { ...data, file_infos: kept };      // 다른 필드(next_file_info_id 등)는 그대로
  if (Array.isArray(data.order)) {
    out.order = data.order.filter((id) => Object.prototype.hasOwnProperty.call(kept, id));
  }
  return out;
}

export function urlPath(url, base) {
  if (!url) return '';
  try {
    // base 는 상대 주소를 풀기 위한 것뿐 — pathname 은 어느 호스트든 같다.
    return new URL(String(url), base || 'http://localhost/').pathname || '';
  } catch (e) {
    return '';
  }
}

function param(url, key, base) {
  try {
    return new URL(String(url), base || 'http://localhost/').searchParams.get(key);
  } catch (e) {
    return null;
  }
}

// `…/api/v4/channels/<id>/stats` 이고 파일 수를 **세는** 요청이면 채널 id, 아니면 null.
// 🔴 `exclude_files_count` 가 참이면 MM 서버가 `files_count: -1` 을 준다(세지 않았다는 표시) —
//    거기서 빼면 더 이상한 수가 된다.
export function parseStatsChannelId(url, base) {
  const hit = STATS_RE.exec(urlPath(url, base));
  if (!hit) return null;
  const raw = param(url, 'exclude_files_count', base);
  if (raw !== null && TRUTHY.indexOf(String(raw).toLowerCase()) >= 0) return null;
  return hit[1];
}

export function isFileSearchUrl(url, base) {
  return FILE_SEARCH_RE.test(urlPath(url, base));
}

// 요청 바디(MM 은 JSON 문자열로 넘긴다)가 «채널 파일 목록» 요청인가.
export function isChannelFilesTerms(body) {
  if (typeof body !== 'string') return false;
  let parsed = null;
  try { parsed = JSON.parse(body); } catch (e) { return false; }
  if (!parsed || typeof parsed !== 'object') return false;
  return typeof parsed.terms === 'string' && CHANNEL_TERMS_RE.test(parsed.terms);
}

// win 당 1회 설치. 반환 = dispose(fetch 원복). 이미 설치돼 있거나 고칠 수 없으면 null.
// options: { isActive, getStickerCount(channelId) → Promise<{count}>, timeoutMs }
export function setupMmStickerFileFilter(win, options) {
  const opts = options || {};
  if (!win || typeof win.fetch !== 'function' || win.__gwStickerFileFilter) return null;
  const Res = win.Response;
  if (typeof Res !== 'function') return null;   // 응답을 다시 만들 수 없으면 아예 손대지 않는다
  const isActive = typeof opts.isActive === 'function' ? opts.isActive : () => true;
  const getCount = typeof opts.getStickerCount === 'function' ? opts.getStickerCount : null;
  const timeoutMs = Number.isFinite(opts.timeoutMs) ? opts.timeoutMs : DEFAULT_TIMEOUT_MS;
  const orig = win.fetch;
  const inflight = new Map();     // 채널 → 진행 중 조회(캐시 아님 — 끝나면 지운다)
  let disposed = false;

  // 원본 헤더를 그대로 옮긴다. 본문 길이가 달라지므로 길이·인코딩만 뗀다.
  function headersOf(res) {
    const out = {};
    let hasType = false;
    try {
      if (res.headers && typeof res.headers.forEach === 'function') {
        res.headers.forEach((value, name) => {
          const key = String(name).toLowerCase();
          if (DROP_HEADERS.indexOf(key) >= 0) return;
          if (key === 'content-type') hasType = true;
          out[name] = value;
        });
      }
    } catch (e) { /* 헤더를 못 읽는 응답 — 최소 content-type 만 세운다 */ }
    // 🔴 MM 은 content-type 이 정확히 application/json 이어야 json() 으로 읽는다.
    if (!hasType) out['content-type'] = 'application/json';
    return out;
  }

  function rebuild(res, body) {
    return new Res(JSON.stringify(body), {
      status: res.status, statusText: res.statusText, headers: headersOf(res),
    });
  }

  // 상한 안에 안 끝나거나 실패하면 0 — «빼지 않는다»(원래 수가 보인다).
  function guard(promise) {
    return new Promise((resolve) => {
      let settled = false;
      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        resolve(0);
      }, timeoutMs);
      const finish = (value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      };
      promise.then((value) => finish(value), () => finish(0));
    });
  }

  // 🔴 캐시하지 않는다 — 채널 정보는 열 때 한 번 묻는 자리라, 방금 보낸 스티커도 맞게 빠져야 한다.
  //    같은 채널의 **진행 중** 요청만 공유한다(동시 두 번이면 조회 1번).
  function stickerCount(channelId) {
    if (!getCount) return Promise.resolve(0);
    const hit = inflight.get(channelId);
    if (hit) return hit;
    let asked = null;
    try { asked = Promise.resolve(getCount(channelId)); } catch (e) { asked = Promise.reject(e); }
    const pending = guard(asked.then((data) => {
      const n = data && typeof data.count === 'number' ? data.count : 0;
      return Number.isFinite(n) && n > 0 ? n : 0;
    })).then((n) => {
      inflight.delete(channelId);
      return n;
    });
    inflight.set(channelId, pending);
    return pending;
  }

  async function adjust(res, input, init) {
    if (disposed || !res) return res;
    let live = false;
    try { live = !!res.ok && !!isActive(); } catch (e) { live = false; }
    if (!live) return res;
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!url) return res;
    const base = (win.location && win.location.href) || undefined;

    // ① «채널 파일» 목록 — 스티커 항목만 뺀다.
    if (isFileSearchUrl(url, base) && isChannelFilesTerms(init && init.body)) {
      const body = await res.clone().json();
      const stripped = stripStickerFiles(body);
      if (stripped === body) return res;          // 스티커가 없었다 = 고칠 것이 없다
      return disposed ? res : rebuild(res, stripped);
    }

    // ② 채널 정보 «파일 N» — 스티커 수만큼 뺀다.
    const channelId = parseStatsChannelId(url, base);
    if (channelId) {
      const body = await res.clone().json();
      if (!body || typeof body.files_count !== 'number' || body.files_count < 0) return res;
      const n = await stickerCount(channelId);
      if (!(n > 0) || disposed) return res;
      return rebuild(res, { ...body, files_count: Math.max(0, body.files_count - n) });
    }
    return res;
  }

  function wrapped(input, init) {
    const args = arguments;
    let call = null;
    // 🔴 원래 fetch 를 **같은 인자·같은 this(win)** 로 부른다 — MM 은 호출 시점의 전역 fetch 를
    //    쓰므로(doFetchWithResponse) 여기서 모양이 달라지면 MM 자기 요청이 깨진다.
    try { call = Promise.resolve(orig.apply(win, args)); } catch (e) { call = Promise.reject(e); }
    // 실패는 그대로 흘린다(네트워크 오류를 우리가 삼키지 않는다).
    return call.then((got) => adjust(got, input, init).then(
      (fixed) => fixed || got,
      () => got,                                  // JSON 파싱·조회 실패 → 원래 응답 그대로
    ));
  }

  win.fetch = wrapped;
  win.__gwStickerFileFilter = true;

  return function dispose() {
    if (disposed) return;
    disposed = true;
    try {
      // 🔴 우리 래퍼가 아직 걸려 있을 때만 되돌린다 — 그 사이 누가 또 감쌌으면
      //    fetch 도 가드도 건드리지 않는다(남의 래퍼를 끊어 버리면 MM 이 깨진다).
      if (win.fetch === wrapped) {
        win.fetch = orig;
        try { delete win.__gwStickerFileFilter; } catch (e) { win.__gwStickerFileFilter = false; }
      }
    } catch (e) { /* */ }
    inflight.clear();
  };
}
